<template lang="pug">
    .z-input-zone-cities(v-loader-overlay="progress")
        autocomplete(
            ref="search" 
            v-model="search" property="value" return="id" label="Добавить населённый пункт" display-property="label" v-bind:show-save-btn="true"
            v-on:select="selectCity" v-on:save="addCityToZone" v-bind:callback="getCities" v-on:clear="clearSelectedCity"
        )
        .z-input-zone-cities__preview-city-danger(v-if="selectedCity && selectedCity.zone && parseInt(selectedCity.zone.id) != parseInt(zone.id)")
            md-icon error_outline
            .value
                div 
                    span Внимание! Населённый пункт уже прикреплён к направлению:
                    b {{' ' + selectedCity.zone.name}}
                div При сохранении населённый пункт будет перемещён в текущее направление!
        .z-input-zone-cities__preview-city-danger(v-if="selectedCity && selectedCity.zone && parseInt(selectedCity.zone.id) == parseInt(zone.id)")
            md-icon error_outline
            .value: span Внимание! Населённый пункт уже прикреплён к текущему направлению!
        .z-input-zone-cities__cities-list-container(v-if="zoneCities && zoneCities.length")
            .z-input-zone-cities__cities-label {{'Прикреплённые населённые пункты' + ' (' + zoneCities.length + ')'}}
            .z-input-zone-cities__cities-list.can-scroll
                .z-input-zone-cities__cities-item(v-for="item in zoneCities" v-bind:key="item.id")
                    .value {{ (item.value) ? item.value : item.name }}
                    .actions
                        md-button.md-icon-button.md-dense.small(@click.stop="showRemoveDialog(item)"): md-icon delete
                        md-tooltip(md-direction="top") Открепить населённый пункт
        md-dialog-confirm(
            :md-active.sync="removeDialog"
            md-title="Удалить населённый пункт из направления?"
            md-content="Внимание! Действие необратимо!"
            md-confirm-text="Удалить"
            md-cancel-text="Отмена"
            v-on:md-cancel="removeDialog = false; cityIdToRemove = null;" 
            v-on:md-confirm="removeCityFromZone"
        )
</template>
<script>
    import Autocomplete from '@/components/autocomplete'
    export default {
        name: 'z-input-zone-cities',
        props: {
            zone: {
                type: Object,
                default: () => {
                    return {
                        id: null,
                        name: null,
                        aoguid: null,
                        disid: null,
                        okato: null,
                        parentguid: null,
                        regioncode: null,
                        sort: 100
                    };
                }
            },
        },
        components: {Autocomplete},
        data() {
            return {
                loadKey: 'load-zone-cities-card',
                search: '',
                selectedCity: {},
                zoneCities: [],
                removeDialog: false,
                cityIdToRemove: null
            }
        },
        created() {
            this.$nextTick(() => this.init());
        },
        watch: {
            '$props.zone'() {
                this.$nextTick(() => this.init());
            }
        },
        computed: {
            progress() {
                return this.progressObj[this.loadKey];
            },
            progressObj() {
                return this.$store.state.progressObj;
            }
        },
        methods: {
            init() {
                this.getZoneCities();
                if (this.$refs.search) this.$refs.search.onClear();
            },
            clearSelectedCity() {
                this.selectedCity = Object.assign({}, {});
            },
            getZoneCities() {
                if (!this.zone || !this.zone.id) return;
                this.$store.commit('showProgressBar', this.loadKey);
                return this.$store.dispatch('cost/getCitiesByZone', this.zone.id).then(r => {
                    if (r && r.length) this.zoneCities = Object.assign([], r);
                }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
            },
            //автозаполнение города
            getCities(searchString) {
                if (searchString.length >= 3) return this.$store.dispatch('stock/getCities', { name: searchString }).then(r => {
                    if (!r || !r.length) r = [];
                    let existsNames = [];
                    r = r.map(item => {
                        existsNames.push(item.name);
                        if (!item.value) item.value = item.name;
                        item.label = item.value; 
                        return item;
                    });
                    return this.suggestCity(searchString, existsNames).then(suggest => {r = r.concat(suggest); return r;});
                });
            },
            suggestCity(searchString, existsNames) {
                return this.$store.dispatch('cost/suggestCity', { string: searchString }).then(r => {
                    let response = [];
                    if (r && r.length) {
                        r = r.filter(item => item && !item.data.street); //Убираем из подсказок адреса, где есть улица т.к это уже не населённый пункт
                        r.filter(item => !!item.unrestricted_value).map(item => {
                            if (item.data.settlement && !(existsNames.indexOf(item.data.settlement + ' ' + item.data.settlement_type)+1)) response.push({
                                id:     'new',
                                name:   item.data.settlement + ' ' + item.data.settlement_type,
                                aoguid: item.data.settlement_fias_id,
                                okato:  item.data.okato,
                                parentguid: (item.data.region_fias_id) ? item.data.region_fias_id : null,
                                disid:      null,
                                regioncode: null,
                                zone_id:    null,
                                sort:       100,
                                label: item.unrestricted_value ? item.unrestricted_value : '',
                                value: item.unrestricted_value ? item.unrestricted_value : '',
                            }); else if (item.data.city && !(existsNames.indexOf(item.data.city + ' ' + item.data.city_type)+1)) response.push({
                                id:     'new',
                                name:   item.data.city + ' ' + item.data.city_type,
                                aoguid: item.data.city_fias_id,
                                okato:  item.data.okato,
                                parentguid: (item.data.region_fias_id) ? item.data.region_fias_id : null,
                                disid:      null,
                                regioncode: null,
                                zone_id:    null,
                                sort:       100,
                                label: item.unrestricted_value ? item.unrestricted_value : '',
                                value: item.unrestricted_value ? item.unrestricted_value : '',
                            });
                        });
                    }
                    return response;
                });
            },
            addCity(city) {
                this.$store.commit('showProgressBar', this.loadKey);
                return this.$store.dispatch('cost/addCity', { city: city }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
            },
            selectCity(id, city) {
                if (!city.value || !city.value.length) city.value = city.name;
                city.label = city.value;
                if (!id || id == 'new') this.addCity(city).then(r => {
                        if (r && r.id) {
                            r.label = r.value;
                            this.selectedCity = Object.assign({}, r);
                        }
                    });
                else this.selectedCity = Object.assign({}, city);
            },
            showRemoveDialog(city) {
                this.removeDialog = true;
                this.cityIdToRemove = city.id;
            },
            addAllCitiesToZone(zoneId) {
                if (!zoneId || !this.zoneCities || !this.zoneCities.length) return new Promise(resolve => {
                    this.$store.commit('showSnackbar', ['Ошибка сохранения городов. Проверьте корректность заполнения', 6000, 'error']);
                    resolve(false);
                });
                let citiesIds = this.zoneCities.map(city => city.id);

                this.$store.commit('showProgressBar', this.loadKey);
                return this.$store.dispatch('cost/addCitiesToZone', { zone_id: zoneId, cities_id: citiesIds}).then(r => {
                    this.$store.commit('showSnackbar', ['Города успешно сохранены', 6000, 'success']);
                    return r;
                }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
            },
            addCityToZone() {
                if (!this.selectedCity || !this.selectedCity.id) return;
                if (!this.zone || !this.zone.id) {
                    this.zoneCities.push(this.selectedCity);
                    if (this.$refs.search) this.$refs.search.onClear();
                } else {
                    this.$store.commit('showProgressBar', this.loadKey);
                    return this.$store.dispatch('cost/addCityToZone', { zone_id: this.zone.id, city_id: this.selectedCity.id}).then(r => {
                        if (this.$refs.search) this.$refs.search.onClear();
                        this.getZoneCities();
                    }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
                }
            },
            removeCityFromZone() {
                if (!this.cityIdToRemove) return
                if (!this.zone || !this.zone.id) {
                    let index = undefined;
                    this.zoneCities.map((city, i) => {
                        if (parseInt(this.cityIdToRemove) === parseInt(city.id)) index = i;
                    });
                    if (index || index == 0) this.zoneCities.splice(index, 1);
                } else {
                    this.$store.commit('showProgressBar', this.loadKey);
                    return this.$store.dispatch('cost/deleteCityFromZone', { zone_id: this.zone.id, city_id: this.cityIdToRemove}).then(r => {
                        this.removeDialog   = false;
                        this.cityIdToRemove = null;
                        this.getZoneCities();
                    }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
                }
            }
        }
    }
</script>
<style lang="sass">
    .z-input-zone-cities
        width: 100%
    .z-input-zone-cities__input-container
        display: flex
        align-items: center
        justify-content: space-between
    .z-input-zone-cities__preview-city-danger
        display: flex
        align-items: center
        justify-content: flex-start
        color: red
        font-size: 12px
        line-height: 14px
        margin: 0 0 10px 0
        .md-icon
            color: red !important
            font-size: 22px !important
            margin: 0 5px 0 0
            width: 20px
            height: 20px
            min-height: 20px
            min-width: 20px
    .z-input-zone-cities__cities-list-container
        margin: 20px 0 10px 0
    .z-input-zone-cities__cities-list
        max-height: 600px
        overflow-y: auto
        .z-input-zone-cities__cities-label
            display: block
            font-size: 14px
            line-height: 16px
            margin: 0 0 10px 0
        .z-input-zone-cities__cities-item
            display: flex
            align-items: center
            justify-content: space-between
            margin: 0 0 5px 0
            padding: 2px 6px
            width: 100%
            border: 1px solid #BEBEBE
            box-sizing: border-box
            border-radius: 3px
            cursor: default
            &:hover
                background: #eee
            &:last-child
                margin: 0 0 0 0
            .value
                width: calc(100% - 30px)
                overflow: hidden
                text-overflow: ellipsis
                white-space: nowrap
            .actions
</style>


// WEBPACK FOOTER //
// ZInputZoneCities.vue?1797e9df